import React from 'react';
import { Card } from '../../../../../../CommonComponents/OPL/Card/Card';
import { Box } from '../../../../../../CommonComponents/OPL/Box/Box';
import { Shimmer } from '../../../../../../CommonComponents/OPL/Shimmer/Shimmer';

export const GoalCardLoading = () => {
  return (
    <Box as="li">
      <Card px="16" py="24" css="height:100%">
        <Box display="flex" flex={1} flexDirection="column" css="height:100%">
          <Box display="flex" justifyContent="space-between" mb="16">
            <Box display="flex" alignItems="center">
              <Shimmer width="180px" height="24px" />
            </Box>

            <Shimmer width="60px" height="24px" />
          </Box>

          <Shimmer width="100%" height="2px" mb="16" />

          <Box
            display="flex"
            justifyContent="space-between"
            flexDirection="column"
            flex={1}
            minHeight={120}
          >
            <Shimmer width="80%" height="22px" />

            <Shimmer width="200px" height="22px" />
          </Box>
        </Box>
      </Card>
    </Box>
  );
};
